export const isCertinotError = (error) => {
    return error.userMessage != null;
};
